import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import MainCard from '../../../components/ui-component/cards/MainCard';
import AnimateButton from '../../../components/ui-component/extended/AnimateButton';

import { Grid, CircularProgress, Typography, Button, Box, OutlinedInput, InputLabel, FormControl, Modal } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { getDeviceDetail, getDeviceList } from '../../../../api/get/Device';
import { DeviceStatus, RESPONSE_CODE, responseResult } from '../../../../metadata/constant';

// ==============================|| DEVICE DETAIL ||============================== //

const DisplayInput = styled(OutlinedInput)(({ theme }) => ({
    '& .MuiInputBase-input.Mui-disabled': {
        WebkitTextFillColor: theme.palette.text.primary
    }
}));

const DeviceDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const theme = useTheme();

    const [device, setDevice] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [openModal, setOpenModal] = useState(0);

    useEffect(() => {
        const fetchDeviceDetail = async () => {
            try {
                const response = await getDeviceDetail(id);
                if (responseResult(response.code) === RESPONSE_CODE.SUCCESS) {
                    setDevice(response.data);
                } else {
                    setDevice({});
                    setError('기기 상세 조회 중 오류가 발생하였습니다.');
                }
            } catch (err) {
                setError(err.message || '기기 상세 조회 중 오류가 발생하였습니다.');
            } finally {
                setLoading(false);
            }
        };

        fetchDeviceDetail();
    }, [id]);

    const handleShowRegistrationCode = () => {
        setOpenModal(1);
    };

    const handleModify = () => {
        navigate(`/management/license/device/${id}/edit`);
    };

    const handleModalClose = () => {
        setOpenModal(0);
    };

    const titleButton = () => {
        return (
            <AnimateButton>
                <Button disableElevation size="large" variant="contained" color="primary" onClick={handleModify}>
                    기기 정보 수정
                </Button>
            </AnimateButton>
        );
    };

    return (
        <>
            <Grid container rowSpacing={4.5} columnSpacing={2.75}>
                <Grid item xs={12}>
                    <MainCard title="기기 상세 정보" titleButtons={titleButton}>
                        {loading ? (
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
                                <CircularProgress />
                            </div>
                        ) : error ? (
                            <Typography color="error" variant="body1" align="center" sx={{ padding: '2rem' }}>
                                {error}
                            </Typography>
                        ) : device ? (
                            <>
                                <Box sx={{ pt: 2, pb: 2 }}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <InputLabel required htmlFor="outlined-adornment-device-name">
                                                    기기명
                                                </InputLabel>
                                                <DisplayInput
                                                    id="outlined-adornment-device-name"
                                                    type="text"
                                                    value={device.device_name ? device.device_name : '-'}
                                                    name="deviceName"
                                                    label="기기명"
                                                    disabled
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="outlined-adornment-memo">메모</InputLabel>
                                                <DisplayInput
                                                    id="outlined-adornment-memo"
                                                    type="text"
                                                    value={device.memo ? device.memo : '-'}
                                                    name="memo"
                                                    label="메모"
                                                    disabled
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="outlined-adornment-status">기기 등록 상태</InputLabel>
                                                <DisplayInput
                                                    id="outlined-adornment-status"
                                                    type="text"
                                                    value={device.status ? DeviceStatus[device.status] : '-'}
                                                    name="status"
                                                    label="기기 등록 상태"
                                                    disabled
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="outlined-adornment-ip">IP</InputLabel>
                                                <DisplayInput
                                                    id="outlined-adornment-ip"
                                                    type="text"
                                                    value={device.ip_address ? device.ip_address : '-'}
                                                    name="ip"
                                                    label="IP"
                                                    disabled
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="outlined-adornment-mac">MAC</InputLabel>
                                                <DisplayInput
                                                    id="outlined-adornment-mac"
                                                    type="text"
                                                    value={device.mac_address ? device.mac_address : '-'}
                                                    name="mac"
                                                    label="MAC"
                                                    disabled
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="outlined-adornment-created-at">등록일시</InputLabel>
                                                <DisplayInput
                                                    id="outlined-adornment-created-at"
                                                    type="text"
                                                    value={device.created_at ? device.created_at : '-'}
                                                    name="created_at"
                                                    label="등록일시"
                                                    disabled
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="outlined-adornment-last-used-at">마지막 사용일시</InputLabel>
                                                <DisplayInput
                                                    id="outlined-adornment-last-used-at"
                                                    type="text"
                                                    value={device.last_used ? device.last_used : '-'}
                                                    name="last_used_at"
                                                    label="마지막 사용일시"
                                                    disabled
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="outlined-adornment-status">기기 등록 상태</InputLabel>
                                                <DisplayInput
                                                    id="outlined-adornment-status"
                                                    type="text"
                                                    value={device.status ? DeviceStatus[device.status] : '-'}
                                                    name="status"
                                                    label="기기 등록 상태"
                                                    disabled
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Box>
                                {DeviceStatus[device.status] === DeviceStatus.COM020_1 && (
                                    <Box sx={{ width: '100%', display: 'flex', gap: 2 }}>
                                        <AnimateButton style={{ width: '100%' }}>
                                            <Button
                                                disableElevation
                                                fullWidth
                                                size="large"
                                                variant="contained"
                                                color="primary"
                                                onClick={handleShowRegistrationCode}
                                                disabled={
                                                    DeviceStatus[device.status] === DeviceStatus.COM020_2 ||
                                                    DeviceStatus[device.status] === DeviceStatus.COM020_3
                                                }
                                            >
                                                인증번호 확인
                                            </Button>
                                        </AnimateButton>
                                    </Box>
                                )}
                            </>
                        ) : (
                            <Typography variant="body1" align="center" sx={{ padding: '2rem' }}>
                                기기 정보를 찾을 수 없습니다.
                            </Typography>
                        )}
                    </MainCard>
                </Grid>
            </Grid>
            <Modal open={openModal > 0} onClose={handleModalClose}>
                <Box sx={theme.typography.modal}>
                    {openModal === 1 ? (
                        <>
                            <Typography id="modal-modal-title" variant="h3" component="h2">
                                기기 등록 인증번호
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2, lineHeight: 1.8 }}>
                                아래의 인증 번호를 브레인 가드 닥터 서비스의 인증 번호 란에 입력하여 등록을 진행해 주세요.
                                <br />
                                자세한 기기 등록 방법은 사용자 메뉴얼을 참고하세요.
                            </Typography>
                            <Typography id="modal-modal-content" variant="h1" component="h1" sx={{ margin: 5, justifySelf: 'center' }}>
                                {device.cert_code ? device.cert_code : '-'}
                            </Typography>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                <AnimateButton>
                                    <Button
                                        disableElevation
                                        size="large"
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        onClick={handleModalClose}
                                    >
                                        확인
                                    </Button>
                                </AnimateButton>
                            </Box>
                        </>
                    ) : (
                        <></>
                    )}
                </Box>
            </Modal>
        </>
    );
};

export default DeviceDetail;
